<div>

  <h3 class="center" anessaTranslation="RESULTS.HISTORY_PICKER.HEADER"></h3>
  <p class="center" anessaTranslation="RESULTS.HISTORY_PICKER.DESCRIPTION"></p>

  <div class="table-wrapper">
    <table mat-table [dataSource]="listData" [multiTemplateDataRows]="true" class="table">
      <ng-container matColumnDef="star">
        <td mat-cell *matCellDef="let set">
          <div class="cell star"
               [ngClass]="{ 'favouriteDisabled': !canEditPlant() }"
               (click)="canEditPlant() && toggleFavourite(set)">
            <i class="material-icons gold" *ngIf="set.starred">star</i>
            <i class="material-icons"  *ngIf="!set.starred">star_border</i>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <td mat-cell *matCellDef="let set">
          <div class="cell time" (click)="onClick(set)"
               [ngClass]="{'current': isSelected(set)}">
            {{set.name ? set.name : getDateInFormat(set.timestamp)}}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="latest-name">
        <td mat-cell *matCellDef="let set">
          <div class="cell time" (click)="onClickLatest()"
               [ngClass]="{'current': currentSelection === 'latest'}">
            {{('RESULTS.HISTORY_PICKER.LATEST' | anessaTranslation: trigger) + ' (' + (getDateInFormat(set.timestamp)) + ')'}}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="export">
        <td mat-cell *matCellDef="let set">
          <div class="cell" (click)="onExportClick(set)" *ngIf="Utils.isDBAdmin()">
            <i class="material-icons">save_alt</i>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <td mat-cell *matCellDef="let set">
          <div *ngIf="Utils.isDBAdmin()"
               class="cell"
               (click)="renameResult(set)"
               anessaTranslation="RESULTS.HISTORY_PICKER.EDIT_NAME">
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="empty">
        <td mat-cell *matCellDef="let set"></td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: ['empty', 'latest-name', 'export', 'empty']; when: isFirstRow" ></tr>
      <tr mat-row *matRowDef="let row; columns: ['star', 'name', 'export', 'edit'];" ></tr>
    </table>
  </div>

  <div *ngIf="listData && listData.length === 0"><p anessaTranslation="RESULTS.HISTORY_PICKER.NO_HISTORY_AVAILABLE"></p></div>
  <div class="button-row flex-container flex-center">
    <button mat-button (click)="onCancelClick()" class="btn-red" anessaTranslation="PROJECT.COMMON.CANCEL"></button>
  </div>

</div>

